import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { NotificationFieldComponent } from '@features/notification-field/notification-field.component';

@Component({
    template: ` <app-notification-field [notification]="params.value" /> `,
    imports: [NotificationFieldComponent],
})
export class NotificationCellComponent implements ICellRendererAngularComp {
    public params!: ICellRendererParams;

    agInit(params: ICellRendererParams): void {
        this.params = params;
    }

    refresh() {
        return false;
    }
}
